/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import React from "react";

import { IconButton } from "src/components/UI/Buttons/IconButtons/IconButton";
import { Expand as ExpandIcon } from "src/components/UI/Icons";

interface Props {
  expand: () => void;
  numConnects: number;
  id: string;
  styles?: React.CSSProperties;
}
export function Expand({ expand, numConnects, id, styles }: Props) {
  return (
    <IconButton isSelected={false} handleClick={expand} tooltipText="Expand block" id={id} styles={styles}>
      {numConnects ? <>{numConnects}</> : <ExpandIcon />}
    </IconButton>
  );
}
